import { STATUS_LABEL } from '../lib/format';
import type { ApiOrderStatus } from '../types/api';

const STYLES: Record<ApiOrderStatus, string> = {
  pending: 'bg-amber-100 text-amber-800 ring-amber-200',
  paid: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
  closed: 'bg-gray-200 text-gray-700 ring-gray-300',
  expired: 'bg-rose-100 text-rose-800 ring-rose-200',
  failed: 'bg-red-100 text-red-800 ring-red-200',
};

export function StatusBadge({ status }: { status: ApiOrderStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${STYLES[status]}`}
    >
      {STATUS_LABEL[status] ?? status}
    </span>
  );
}
